"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/toConsumableArray.js"));
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.includes.js");
var _vue = _interopRequireDefault(require("vue"));
var _default = exports.default = {
  namespaced: true,
  state: {
    undotypecodes: [],
    // 数据字典待处理编码
    datamap: {} // 数据字典缓存数据
  },
  getters: {
    getDataMap: function getDataMap(state) {
      return function (typeCode) {
        return state.datamap[typeCode];
      };
    },
    // 下拉类型的数据
    getDataSelect: function getDataSelect(state) {
      return function (typeCode, isNum) {
        var obj = state.datamap[typeCode];
        var list = [];
        for (var key in obj) {
          var dict = {};
          dict.dictKey = key;
          if (isNum) {
            dict.dictKey = parseInt(key);
          }
          dict.dictValue = obj[key];
          list.push(dict);
        }
        return list;
      };
    }
  },
  mutations: {
    addUndoTypeCodes: function addUndoTypeCodes(state) {
      var _state$undotypecodes;
      for (var _len = arguments.length, typecodes = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        typecodes[_key - 1] = arguments[_key];
      }
      typecodes = typecodes.filter(function (item) {
        return !state.undotypecodes.includes(item);
      });
      typecodes = typecodes.filter(function (item) {
        return !state.datamap[item];
      });
      (_state$undotypecodes = state.undotypecodes).push.apply(_state$undotypecodes, (0, _toConsumableArray2.default)(typecodes));
    },
    getUndisposedTypeCodes: function getUndisposedTypeCodes(state) {
      return state.undotypecodes;
    },
    addDataMap: function addDataMap(state, item) {
      for (var key in item) {
        _vue.default.set(state.datamap, key, item[key]);
      }
      state.undotypecodes = [];
    },
    resetStateDataMap: function resetStateDataMap(state) {
      state.undotypecodes = []; // 数据字典待处理编码
      state.datamap = {}; // 数据字典缓存数据
    }
  }
};